import { createContext } from "react";

//types
import { TableColumnsItem } from "../../../../common/FiltersComponents/TableSettings/types";

interface ITrackersContext {
  selectedTrackers: TableColumnsItem[],
  setSelectedTrackers: (data: any) => void;
  addSelectedTrackers: (data: any) => void;
}

export const TrackersContext = createContext<ITrackersContext>({
  selectedTrackers: [],
  setSelectedTrackers: () => {},
  addSelectedTrackers: () => {},
});
